export default __webpack_public_path__ + "static/media/mail.1367f296.svg";